<app-floorplan-product-menu
  [title]="tooltipTextPlasticSigns"
  [hasConfigurations]="plasticSigns.length > 0"
  [visible]="floorplan.floorplanState.plasticSignsVisible"
  [locked]="floorplan.floorplanState.plasticSignsLocked"
  [itemTextVisible]="floorplan.floorplanState.plasticSignsItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.plasticSignsVisible = $event"
  (lockUpdate)="floorplan.floorplanState.plasticSignsLocked = $event"
  (itemTextVisibilityUpdate)="updatePlasticSignsItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="plastic-sign"
>
  @for (plasticSign of plasticSigns; track plasticSign) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="plasticSign"
        [numberOfFloorplanItems]="floorplan.countPlacedPlasticSigns(plasticSign)"
        (add)="addPlasticSign(plasticSign)"
        (delete)="deletePlasticSign(plasticSign)"
        (dragStart)="drag(plasticSign)"
        [subtitlePrefix]="
          plasticSign.text && plasticSign.textColor && plasticSign.backgroundColor
            ? plasticSign.text + ', ' + plasticSign.textColor + ', ' + plasticSign.backgroundColor
            : ''
        "
        editPath="plastic-sign"
        imageUrl="./assets/icons-blue/kunststoffschild_blau.svg"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
